import React, { useEffect } from 'react'
import { AlertProps } from '@mui/material'
import posthog from 'posthog-js'
import { Flex } from '../../components/Flex'
import { Box } from '../../components/Box'
import { WelcomeStep } from './ProfileSteps/WelcomeStep'
import { Layout } from '../../components/Layout'
import { ProfileBoxContent } from './ProfileSteps/styles'
import { SnackAlert } from '../../components/SnackAlert'
import { AccountingStyleStep } from './ProfileSteps/AccountingStyleStep'
import { useUsersQuery } from '../../graphql/generated'
import { FortnoxContext } from '../../context/FortnoxContext'
import { appHistory } from '../../utils/history'

export enum Steps {
  Welcome,
  Accounting,
}

export function AccountantConfPage(): React.JSX.Element {
  const [currentStep, setCurrentStep] = React.useState<Steps>(Steps.Welcome)
  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    'children' | 'severity'
  > | null>(null)
  const { getData } = React.useContext(FortnoxContext)

  const handleCloseSnackbar = () => setSnackbar(null)

  const { loading: usersLoading, error } = useUsersQuery({
    variables: {},
  })

  useEffect(() => {
    if (error) {
      setSnackbar({
        children: 'Något gick fel, ladda om sidan och försök igen',
        severity: 'error',
      })
    }
  }, [error])

  const goToNextStep = React.useCallback(() => {
    switch (currentStep) {
      case Steps.Welcome:
        setCurrentStep(Steps.Accounting)
        break
      case Steps.Accounting:
        getData()
        appHistory.push('/emission')
        break
      default:
        setCurrentStep(Steps.Welcome)
    }
  }, [currentStep, getData])

  useEffect(() => {
    posthog.capture(`view-step-accounting-${currentStep}`)
  }, [currentStep])

  const getContent = () => {
    switch (currentStep) {
      case Steps.Accounting:
        return (
          <AccountingStyleStep
            goToNextStep={goToNextStep}
            setSnackbar={setSnackbar}
          />
        )
      default:
        return (
          <WelcomeStep goToNextStep={goToNextStep} loading={usersLoading} />
        )
    }
  }

  return (
    <Layout title='Välkommen' hideJobButton>
      <Flex column itemsCenter data-testid='profile-creation'>
        <Box style={{ width: '820px' }}>
          <ProfileBoxContent>{getContent()}</ProfileBoxContent>
        </Box>

        <SnackAlert
          open={!!snackbar}
          onClose={handleCloseSnackbar}
          {...snackbar}
        />
      </Flex>
    </Layout>
  )
}
